import { TextRun } from 'docx';

import {
  TIME_TRACKER_EXPORT_DOCX_TEXT_RUN_HALF_POINTS,
  TIME_TRACKER_EXPORT_FONT_NAME,
} from './timeTrackerExportFont';

/**
 * Arial 8pt for all TimeTracker DOCX exports (size in half-points).
 * Ignores any `size` / `font` passed in options so typography stays consistent.
 */
export function createTimeTrackerDocxTextRun(text, options = {}) {
  const { font: _f, size: _s, ...rest } = options;
  return new TextRun({
    text,
    font: TIME_TRACKER_EXPORT_FONT_NAME,
    size: TIME_TRACKER_EXPORT_DOCX_TEXT_RUN_HALF_POINTS,
    ...rest,
  });
}
